import { ResponsiveContainer, BarChart, Bar, LineChart, Line, AreaChart, Area, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";

const AXIS = { fontSize: 11, fill: "hsl(var(--muted-foreground))", fontFamily: "var(--font-ui)" };
const GRID = "hsl(var(--border))";
const tip = {
  contentStyle: { background: "hsl(var(--popover))", border: "1px solid hsl(var(--border))", borderRadius: 10, fontSize: 12, color: "hsl(var(--popover-foreground))" },
  labelStyle: { color: "hsl(var(--muted-foreground))" },
};
export const PALETTE = ["hsl(var(--chart-1))", "hsl(var(--chart-2))", "hsl(var(--chart-3))", "hsl(var(--chart-4))", "hsl(var(--chart-5))"];

export const BarCard = ({ data, xKey, yKey, height = 260, color = "hsl(var(--chart-1))", horizontal = false, fmt }) => (
  <ResponsiveContainer width="100%" height={height}>
    <BarChart data={data} layout={horizontal ? "vertical" : "horizontal"} margin={{ top: 6, right: 12, left: horizontal ? 8 : 0, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={GRID} opacity={0.5} vertical={!horizontal} horizontal={horizontal ? false : true} />
      {horizontal ? <><XAxis type="number" tick={AXIS} tickFormatter={fmt} /><YAxis type="category" dataKey={xKey} tick={AXIS} width={110} /></>
        : <><XAxis dataKey={xKey} tick={AXIS} interval="preserveStartEnd" /><YAxis tick={AXIS} tickFormatter={fmt} width={44} /></>}
      <Tooltip {...tip} formatter={fmt ? (v) => fmt(v) : undefined} cursor={{ fill: "hsl(var(--muted))", opacity: 0.4 }} />
      <Bar dataKey={yKey} fill={color} radius={horizontal ? [0, 6, 6, 0] : [6, 6, 0, 0]} maxBarSize={horizontal ? 22 : 46} />
    </BarChart>
  </ResponsiveContainer>
);

export const AreaCard = ({ data, xKey, yKey, height = 240, color = "hsl(var(--chart-1))", fmt }) => (
  <ResponsiveContainer width="100%" height={height}>
    <AreaChart data={data} margin={{ top: 6, right: 12, left: 0, bottom: 0 }}>
      <defs><linearGradient id={`g-${yKey}`} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={color} stopOpacity={0.25} /><stop offset="100%" stopColor={color} stopOpacity={0} /></linearGradient></defs>
      <CartesianGrid strokeDasharray="3 3" stroke={GRID} opacity={0.5} vertical={false} />
      <XAxis dataKey={xKey} tick={AXIS} interval="preserveStartEnd" minTickGap={28} />
      <YAxis tick={AXIS} tickFormatter={fmt} width={48} />
      <Tooltip {...tip} formatter={fmt ? (v) => fmt(v) : undefined} />
      <Area type="monotone" dataKey={yKey} stroke={color} strokeWidth={2} fill={`url(#g-${yKey})`} />
    </AreaChart>
  </ResponsiveContainer>
);

export const LineCard = ({ data, xKey, series, height = 240, fmt }) => (
  <ResponsiveContainer width="100%" height={height}>
    <LineChart data={data} margin={{ top: 6, right: 12, left: 0, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={GRID} opacity={0.5} vertical={false} />
      <XAxis dataKey={xKey} tick={AXIS} /><YAxis tick={AXIS} tickFormatter={fmt} width={44} />
      <Tooltip {...tip} /><Legend wrapperStyle={{ fontSize: 12 }} />
      {series.map((s, i) => <Line key={s.key} type="monotone" dataKey={s.key} name={s.name} stroke={PALETTE[i % PALETTE.length]} strokeWidth={2} dot={false} />)}
    </LineChart>
  </ResponsiveContainer>
);

export const DonutCard = ({ data, nameKey, valueKey, height = 260, fmt }) => (
  <ResponsiveContainer width="100%" height={height}>
    <PieChart>
      <Pie data={data} dataKey={valueKey} nameKey={nameKey} innerRadius="55%" outerRadius="82%" paddingAngle={2}>
        {data.map((_, i) => <Cell key={i} fill={PALETTE[i % PALETTE.length]} />)}
      </Pie>
      <Tooltip {...tip} formatter={fmt ? (v) => fmt(v) : undefined} /><Legend wrapperStyle={{ fontSize: 12 }} />
    </PieChart>
  </ResponsiveContainer>
);
